import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { ManorContext } from '@comparethemarketau/manor-provider';
import { Logo } from '@comparethemarketau/manor-logo';
import { replaceBaseUrl } from 'ctm-util-functions';
import { useEverestConfig } from 'ctm-app/client/hooks/useEverestConfig';
import { getHeaderLink, getHeaderUrl, getSmallHeaderUrl } from 'ctm-selectors/selectors/brand_content';

const BrandedLogo = ({ size, className }) => {
    const { breakpoints: { lg } } = useContext(ThemeContext);
    const { breakpoint, trackInteraction } = useContext(ManorContext);
    const { brandcode } = useEverestConfig();
    const headerUrl = useSelector(getHeaderUrl);
    const smallHeaderUrl = useSelector(getSmallHeaderUrl);
    const headerLink = useSelector(getHeaderLink);

    // Default to the small header (existing behaviour)
    // Fallback to the large header if the small header is not available
    let imgSrc = smallHeaderUrl ?? headerUrl;

    if (breakpoint === 'md' && smallHeaderUrl) {
        imgSrc = smallHeaderUrl;
    } else if (breakpoint !== 'xs') {
        imgSrc = headerUrl;
    }

    // Replace the base URL as the image URLs are relative
    imgSrc = replaceBaseUrl(imgSrc);

    const trackClickEvent = () => trackInteraction('Click', 'Logo', `${brandcode.toUpperCase()} Logo`, '', headerLink);

    return (
        <Logo
            size={size}
            link={headerLink}
            handleClick={trackClickEvent}
            picture={{
                src: imgSrc,
                srcsets: [
                    {
                        media: `(max-width: ${lg})`,
                        srcset: replaceBaseUrl(smallHeaderUrl)
                    },
                    {
                        srcset: replaceBaseUrl(headerUrl)
                    }
                ],
                className
            }}
        />
    );
};

BrandedLogo.propTypes = {
    // Important that manor gets the size prop
    size: PropTypes.oneOf(['small', 'large']),
    className: PropTypes.string
};

BrandedLogo.defaultProps = {
    size: 'large',
    className: ''
};

export default BrandedLogo;
